import React, { useState } from "react";
import Balance from "../services/getBalance";

function Footer() {
  const [balance, setBalance] = useState("0");
  const [show, setShow] = useState(false);

  function checkBalanceApi(event) {
    event.preventDefault();
    if (!show) {
      return;
    }
    return Balance.getBalance(event)
      .then((res) => {
        setBalance(res);
      })
      .catch((err) => alert({ err }));
  }

  function toggleBalanceVisibility() {
    setShow(true);
    setTimeout(() => setShow(false), 5000);
  }
  return (
    <div className="fixed bottom-0 right-0">
      {show && (
        <div className="absolute bottom-0 right-12 text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
          {balance}
        </div>
      )}
      <div className="absolute bottom-0 right-0">
        <form
          className="d-flex flex-column"
          style={{ gap: "10px" }}
          onSubmit={checkBalanceApi}
          onClick={toggleBalanceVisibility}
        >
          <button
            type="submit"
            className="text-white bottom-0 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 "
          >
            $
          </button>
        </form>
      </div>
    </div>
  );
}

export default Footer;
